export enum RouteKeys {
  List = '/category',
  New = '/category/new',
  Edit = '/category/:id',
}
